import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import './newsSlider.scss';

const NewsSlider = (props) => {
  const {
    imgSource,
    newsTitle,
    newsDescription,
    parentClassName,
    className,
    reserve,
  } = props;
  return (
    <div className={`${parentClassName}`}>
      <div className={`${className}`}>
        <div className="newsCard__image-container">
          <img
            className="w-100 newsCard__image image-height"
            src={require(`../../../content/images/elements//${imgSource}`)}
            alt="news Card airline airport"
          />
        </div>
        <svg className="newsCard__svg pt-2" viewBox="0 0 800 500">
          <path
            d="M 0 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 800 400 L 800 500 L 0 500"
            stroke="transparent"
            fill="#f5f7fb"
          />
          <path
            className="newsCard__line"
            d="M 0 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 800 400"
            stroke="pink"
            strokeWidth={3}
            fill="transparent"
          />
        </svg>
        <div className="newsCard__content text-start">
          <h1 className="text-secondary font-xl-large font-normal">
            <FormattedMessage id={newsTitle} />
          </h1>
          <p className="font-xl-small font-msmall">
            <FormattedMessage id={newsDescription} />
          </p>
        </div>
        {reserve && (
          <div className="d-flex justify-content-center col-12 px-0">
            <div
              className="d-flex col-xl-6 col-12 px-0 py-2 justify-content-center cursor-pointer bg-secondary text-white rounded-pill"
              style={
                {
                  // backgroundColor: "#2b3056",
                  // borderRadius: "7px",
                  // color: "#45f2fe",
                }
              }
            >
              <span className="w-100 text-center text-nowrap text-truncate px-2">
                <FormattedMessage id={reserve} />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

NewsSlider.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.shape({
      en: PropTypes.string,
      fa: PropTypes.string,
    }),
    detail: PropTypes.shape({
      en: PropTypes.string,
      fa: PropTypes.string,
    }),
    date: PropTypes.string,
    user: PropTypes.string,
    userDetail: PropTypes.shape({
      en: PropTypes.string,
      fa: PropTypes.string,
    }),
    userIcon: PropTypes.string,
  }),
  parentClassName: PropTypes.string,
  newsDescription: PropTypes.string,
  newsTitle: PropTypes.string,
  imgSource: PropTypes.string,
  className: PropTypes.string,
  reserve: PropTypes.string,
};

NewsSlider.defaultProps = {
  data: {
    userIcon: '../../../content/images/news/news-user.jpg',
    parentClassName: '',
  },
  parentClassName: '',
  newsDescription: '',
  newsTitle: 'booking.flights',
  imgSource: 'flight2.jpg',
  className: '',
  reserve: '',
};
export default injectIntl(NewsSlider);
